/**
 * Collection page layout:
 * filter drawer, card carousel, load more, sticky toolbar.
 */
(function () {
  var section = document.querySelector("[data-collection-section]");
  if (!section) return;

  var grid = section.querySelector("[data-collection-grid]");
  var filterDrawer = section.querySelector("[data-collection-filter-drawer]");
  var stickyBar = section.querySelector("[data-collection-sticky-bar]");
  var facets = section.querySelector("#main-collection-filters");
  var filterForm = section.querySelector("[data-collection-filters]");
  var loadMoreBtn = section.querySelector("[data-collection-load-more]");
  var sectionId = section.getAttribute("data-section-id");

  if (grid) {
    grid.setAttribute("data-view-desktop", "4");
    grid.setAttribute("data-view-mobile", "2");
  }

  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute("aria-hidden", "false");
    filterDrawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute("aria-hidden", "true");
    filterDrawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  section.addEventListener("click", function (e) {
    if (e.target.closest("[data-collection-filter-open]")) {
      e.preventDefault();
      openFilterDrawer();
      return;
    }
    if (e.target.closest("[data-collection-filter-close]")) {
      e.preventDefault();
      closeFilterDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeFilterDrawer();
  });

  function initCarousels(root) {
    (root || section).querySelectorAll("[data-collection-carousel]").forEach(function (carousel) {
      if (carousel.getAttribute("data-carousel-init") === "true") return;
      carousel.setAttribute("data-carousel-init", "true");

      var track = carousel.querySelector("[data-collection-carousel-track]");
      var prev = carousel.querySelector("[data-collection-carousel-prev]");
      var next = carousel.querySelector("[data-collection-carousel-next]");
      if (!track) return;

      var slides = track.querySelectorAll(".collection-card__slide");
      var hasUserInteracted = false;

      function slideBy(direction) {
        var slide = track.querySelector(".collection-card__slide");
        if (!slide) return;
        track.scrollBy({ left: direction * slide.offsetWidth, behavior: "smooth" });
      }

      function jumpToSlide(index) {
        var slide = slides[0];
        if (!slide || !slides[index]) return;
        var prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = "auto";
        track.scrollLeft = index * slide.offsetWidth;
        requestAnimationFrame(function () {
          track.style.scrollBehavior = prevBehavior;
        });
      }

      function markInteracted() {
        hasUserInteracted = true;
      }

      prev?.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        markInteracted();
        slideBy(-1);
      });
      next?.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        markInteracted();
        slideBy(1);
      });

      // Desktop hover preview: show second image on hover.
      // Disabled after the shopper uses carousel arrows.
      if (
        slides.length > 1 &&
        window.innerWidth > 767 &&
        window.matchMedia("(hover: hover) and (pointer: fine)").matches
      ) {
        carousel.addEventListener("mouseenter", function () {
          if (hasUserInteracted) return;
          jumpToSlide(1);
        });
        carousel.addEventListener("mouseleave", function () {
          if (hasUserInteracted) return;
          jumpToSlide(0);
        });
      }
    });
  }

  function initStickyBar() {
    if (!stickyBar) return;

    /* Show sticky Filter & Sort only after the top control leaves the viewport. */
    var stickyTrigger =
      section.querySelector(".collection-facets__filter") || facets;
    if (!stickyTrigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.setAttribute("aria-hidden", visible ? "true" : "false");
        stickyBar.classList.toggle("is-visible", !visible);
      },
      { root: null, threshold: 0, rootMargin: "0px" },
    );
    observer.observe(stickyTrigger);
  }

  function initLoadMore() {
    if (!loadMoreBtn || !grid || !sectionId) return;

    loadMoreBtn.setAttribute("data-default-text", loadMoreBtn.textContent);
    loadMoreBtn.setAttribute("data-loading-text", "Loading…");

    loadMoreBtn.addEventListener("click", function () {
      var nextUrl = loadMoreBtn.getAttribute("data-next-url");
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-loading-text");

      var fetchUrl =
        nextUrl.indexOf("?") >= 0
          ? nextUrl + "&section_id=" + encodeURIComponent(sectionId)
          : nextUrl + "?section_id=" + encodeURIComponent(sectionId);

      fetch(fetchUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newSection = doc.querySelector("[data-collection-section]");
          if (!newSection) return;

          var newGrid = newSection.querySelector("[data-collection-grid]");
          var newLoadMore = newSection.querySelector("[data-collection-load-more]");
          if (newGrid) {
            Array.from(newGrid.children).forEach(function (child) {
              grid.appendChild(child);
            });
            initCarousels(grid);
            if (window.WearableFavourites) {
              window.WearableFavourites.updateToggleButtons();
            }
          }

          if (newLoadMore) {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-default-text");
            loadMoreBtn.setAttribute("data-next-url", newLoadMore.getAttribute("data-next-url") || "");
          } else {
            loadMoreBtn.closest(".collection__load-more")?.remove();
          }
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = loadMoreBtn.getAttribute("data-default-text");
          window.location.href = nextUrl;
        });
    });
  }

  initCarousels(section);
  initStickyBar();
  initLoadMore();
})();
